import { FRONTEND_ASSET_HOST } from '@sorare/core/src/constants/assets';

export const getVideoSources = ({
  isNew,
  dropRank,
}: {
  isNew: boolean;
  dropRank: Nullable<number>;
}) => {
  const cardTier = typeof dropRank === 'number' ? dropRank : Infinity;
  if (!isNew && cardTier > 3) {
    return null;
  }
  const cardTierString = cardTier > 3 ? '' : `T${cardTier}_`;
  const newString = isNew ? 'new_' : '';

  return {
    av1: `${FRONTEND_ASSET_HOST}/animations/packs/${cardTierString}${newString}av1.mp4`,
    hevc: `${FRONTEND_ASSET_HOST}/animations/packs/${cardTierString}${newString}hevc.mp4`,
  };
};
